import { fg } from '@atlaskit/platform-feature-flags/fg';

import { functionWithCondition } from '../function-with-condition/functionWithCondition';

export const functionWithFG = <Fn extends (...args: any[]) => any>(
	featureFlagName: string,
	functionTrue: Fn,
	functionFalse: Fn,
	// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/static-feature-flags
): Fn => functionWithCondition(() => fg(featureFlagName), functionTrue, functionFalse);
